var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',[_vm._v("Movimientos:")]),_vm._l((_vm.actions),function(action){return _c('div',{key:action},[_vm._v(" - "+_vm._s(action)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }